import { render, staticRenderFns } from "./AziendaCal.vue?vue&type=template&id=a406d528&scoped=true&"
import script from "./AziendaCal.vue?vue&type=script&lang=js&"
export * from "./AziendaCal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a406d528",
  null
  
)

export default component.exports